"use strict";

var _slicedToArray = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _regeneratorRuntime = require("/agent/_work/1/s/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/createClass.js");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var async_lib_1 = require("../async-lib/async-lib");
var common_1 = require("../common/common");
var AmplitudeHelper = /*#__PURE__*/function () {
  function AmplitudeHelper(applicationName) {
    _classCallCheck(this, AmplitudeHelper);
    this.applicationName = applicationName;
    if (common_1.isBrowser()) {
      this.asyncAmplitude = new async_lib_1.AsyncLib("amplitude", window);
    }
  }
  _createClass(AmplitudeHelper, [{
    key: "sendEvent",
    value: function sendEvent(name) {
      var _this = this;
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (this.asyncAmplitude) {
        return this.asyncAmplitude.get().then(function (ampApi) {
          return ampApi.getInstance();
        }).then(function (instance) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.dispatchUserProperties(instance, user);
                case 2:
                  _context.next = 4;
                  return this.dispatchEvent(instance, name, event);
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee, this);
          }));
        }).catch(function (e) {
          console.error("Unable to send event", name, user, event, e);
        });
      }
      return Promise.resolve();
    }
  }, {
    key: "setUser",
    value: function setUser(userId) {
      if (this.asyncAmplitude) {
        return this.asyncAmplitude.get().then(function (ampApi) {
          return ampApi.getInstance();
        }).then(function (instance) {
          instance.setUserId(userId);
        }).catch(function (e) {
          console.error("Unable to set user", userId, e);
        });
      }
      return Promise.resolve();
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(instance, name, event) {
      var _this2 = this;
      return new Promise(function (resolve) {
        instance.logEvent(name, Object.assign({
          Application: _this2.applicationName
        }, event), function () {
          return resolve();
        });
      });
    }
  }, {
    key: "dispatchUserProperties",
    value: function dispatchUserProperties(instance, user) {
      return new Promise(function (resolve) {
        var identity = new instance.Identify();
        Object.entries(user).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          if (value) {
            identity.set(key, value);
          }
        });
        instance.identify(identity, function () {
          return resolve();
        });
      });
    }
  }]);
  return AmplitudeHelper;
}();
exports.AmplitudeHelper = AmplitudeHelper;